/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import DueNow from 'DesignSystem/DueNow/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Content/Home/AccountBalance/Content/Content/Content"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let paymentAccountBalanceValueData = fromData.useDataValue({ viewPath,
context: 'payment_account_balance',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<DueNow
  viewPath={`${viewPath}/DueNow`}
 data="payment_account_balance"
 value={paymentAccountBalanceValueData}
 onClick={() => setFlowTo("/App/Account/Content/Content/Financial/AccountContent/Content/TrayContent/PayNow")}
 isSelected={flow.has("/App/Account/Content/Content/Financial/AccountContent/Content/TrayContent/PayNow")}
 marginTop={dtSpaceS}
/>
{children}
</React.Fragment>)
}